<div class="flex h-full w-full bg-white">
    <div class="w-[30%] border-r border-[#dddddd]">
        <app-ticket-list [(activeTicket)]="activeTicket"></app-ticket-list>
    </div>

    <div class="w-[70%] h-full">
        <app-ticket-conversation [ticket]="activeTicket"></app-ticket-conversation>
    </div>
</div>



